export default {"src":"/_next/static/media/receipt_color.64527720.svg","height":32,"width":32};